import React, { useCallback, useState } from 'react';
import InfoModal from '../../../../components/modals/info-modal';

export function useErrorModal() {
  const [errorModal, setErrorModal] = useState<React.ReactElement | null>(null);

  const showError = useCallback((error: any) => {
    const content =
      error?.response?.error || error?.message || error?.error || String(error);
    setErrorModal(
      <InfoModal content={content} onClose={() => setErrorModal(null)} />
    );
  }, []);

  const closeModal = useCallback(() => {
    setErrorModal(null);
  }, []);

  return {
    errorModal,
    showError,
    closeModal,
  };
}
